import React from 'react';
import VerSubheader from '../ver-subheader';
import VerParagraph from '../ver-paragraph';
import VerGrid from '../ver-grid';

const VerContainer: React.FC = () => {
  const rechargePureElectric = [
    {
      image: '/ver/EX30.webp',
      model: 'EX30',
      year: '2024-',
      href: '/ver/Volvo_EX30__SUV_2024_5d_Electric_EN_v2.pdf',
      additionalHref: [
        {
          label: 'ENGLISH',
          href: '/ver/Volvo_EX30__SUV_2024_5d_Electric_EN_v2.pdf',
        },
        {
          label: 'FRENCH',
          href: '/ver/Volvo_EX30__SUV_2024_5d_Electric_FR_v2.pdf',
        },
        {
          label: 'SPANISH',
          href: '/ver/Volvo_EX30__SUV_2024_5d_Electric_ES_v2.pdf',
        },
      ],
    },
    {
      image: '/ver/EX60.webp',
      model: 'EX60',
      year: '2026-',
      href: '/ver/Volvo_EX60__SUV_2026_5d_Electric_EN_ERG.pdf',
      additionalHref: [
        {
          label: 'ENGLISH',
          href: '/ver/Volvo_EX60__SUV_2026_5d_Electric_EN_ERG.pdf',
        },
        {
          label: 'FRENCH',
          href: '/ver/Volvo_EX60__SUV_2026_5d_Electric_FR_ERG.pdf',
        },
        {
          label: 'SPANISH',
          href: '/ver/Volvo_EX60__SUV_2026_5d_Electric_ES_ERG.pdf',
        },
      ],
    },
    {
      image: '/ver/EX90.webp',
      model: 'EX90',
      year: '2024-',
      href: '/ver/Volvo_EX90__SUV_2024_5d_Electric_EN.pdf',
      additionalHref: [
        {
          label: 'ENGLISH',
          href: '/ver/Volvo_EX90__SUV_2024_5d_Electric_EN.pdf',
        },
        {
          label: 'FRENCH',
          href: '/ver/Volvo_EX90__SUV_2024_5d_Electric_FR.pdf',
        },
        {
          label: 'SPANISH',
          href: '/ver/Volvo_EX90__SUV_2024_5d_Electric_ES.pdf',
        },
      ],
    },
    {
      image: '/ver/C40.webp',
      model: 'C40 / EC40',
      year: '2022-2024',
      href: '/ver/Volvo_C40_Recharge_Pure_Electric_SUV_2021_5d_Electric_EN_ERG~001.pdf',
    },
    {
      image: '/ver/XC40.webp',
      model: 'XC40 BEV / EX40',
      year: '2020-2024',
      href: '/ver/MY2021-XC40RechargeFullElectric.pdf',
      additionalHref: [
        {
          label: 'ENGLISH',
          href: '/ver/MY2021-XC40RechargeFullElectric.pdf',
        },
        {
          label: 'FRENCH',
          href: '/ver/ERG_XC40Recharge_2021_FR.pdf',
        },
        {
          label: 'SPANISH',
          href: '/ver/ERG_XC40Recharge_2021_ES.pdf',
        },
      ],
    },
  ];

  const mildHybrid = [
    {
      image: '/ver/S60.webp',
      model: 'S60',
      year: '2022-2024',
      href: '/ver/S60 MHEV Rescue.pdf',
    },
    {
      image: '/ver/S90.webp',
      model: 'S90',
      year: '2022-2024',
      href: '/ver/S90 MHEV Rescue.pdf',
    },
    {
      image: '/ver/V90CC.webp',
      model: 'V90/V90CC',
      year: '2022-2024',
      href: '/ver/V90-V90CC MHEV Rescue.pdf',
    },
    {
      image: '/ver/XC40.webp',
      model: 'XC40',
      year: '2021-2024',
      href: '/ver/XC40 MHEV ERG.pdf',
    },
    {
      image: '/ver/XC60.webp',
      model: 'XC60',
      year: '2022-2024',
      href: '/ver/XC60 MHEV Rescue.pdf',
    },
    {
      image: '/ver/XC90.webp',
      model: 'XC90',
      year: '2023-2024',
      href: '/ver/EGR XC90 MHEV TJI-376947-67_1_1_en-US.pdf',
    },
  ];

  const pluginHybrid = [
    {
      image: '/ver/S60.webp',
      model: 'S60',
      year: '2019-2022',
      href: '/ver/Volvo_S60__Sedan_2018_5d_Hybrid (Electric)_EN.pdf',
      additionalHref: [
        {
          label: 'ENGLISH',
          href: '/ver/Volvo_S60__Sedan_2018_5d_Hybrid (Electric)_EN.pdf',
        },
        {
          label: 'FRENCH',
          href: '/ver/Volvo_S60__Sedan_2018_5d_Hybrid (Electric)_FR.pdf',
        },
        {
          label: 'SPANISH',
          href: '/ver/Volvo_S60__Sedan_2018_5d_Hybrid (Electric)_ES.pdf',
        },
      ],
    },
    {
      image: '/ver/S90.webp',
      model: 'S90',
      year: '2017 only',
      href: '/ver/MY2017-S90-Hybrid.pdf',
    },
    {
      image: '/ver/V60CC.webp',
      model: 'V60',
      year: '2019-2024',
      href: '/ver/Volvo_V60__Stationwagon_2018_5d_Hybrid (Electric)_EN.pdf',
      additionalHref: [
        {
          label: 'ENGLISH',
          href: '/ver/Volvo_V60__Stationwagon_2018_5d_Hybrid (Electric)_EN.pdf',
        },
        {
          label: 'FRENCH',
          href: '/ver/Volvo_V60__Stationwagon_2018_5d_Hybrid (Electric)_FR.pdf',
        },
        {
          label: 'SPANISH',
          href: '/ver/Volvo_V60__Stationwagon_2018_5d_Hybrid (Electric)_ES.pdf',
        },
      ],
    },
    {
      image: '/ver/XC60.webp',
      model: 'XC60',
      year: '2018-2024',
      href: '/ver/Volvo_XC60__SUV_2017_5d_Hybrid (Electric)_EN.pdf',
      additionalHref: [
        {
          label: 'ENGLISH',
          href: '/ver/Volvo_XC60__SUV_2017_5d_Hybrid (Electric)_EN.pdf',
        },
        {
          label: 'FRENCH',
          href: '/ver/Volvo_XC60__SUV_2017_5d_Hybrid (Electric)_FR.pdf',
        },
        {
          label: 'SPANISH',
          href: '/ver/Volvo_XC60__SUV_2017_5d_Hybrid (Electric)_ES.pdf',
        },
      ],
    },
    {
      image: '/ver/XC90.webp',
      model: 'XC90',
      year: '2016-2024',
      href: '/ver/Volvo_XC90__SUV_2015_5d_Hybrid (Electric)_EN.pdf',
      additionalHref: [
        {
          label: 'ENGLISH',
          href: '/ver/Volvo_XC90__SUV_2015_5d_Hybrid (Electric)_EN.pdf',
        },
        {
          label: 'FRENCH',
          href: '/ver/Volvo_XC90__SUV_2015_5d_Hybrid (Electric)_FR.pdf',
        },
        {
          label: 'SPANISH',
          href: '/ver/Volvo_XC90__SUV_2015_5d_Hybrid (Electric)_ES.pdf',
        },
      ],
    },
    {
      image: '/ver/S60L.webp',
      model: 'S60L',
      year: '2016-2018',
      href: '/ver/MY2013-S60L.pdf',
    },
    {
      image: '/ver/S90.webp',
      model: 'S90',
      year: '2018-2024',
      href: '/ver/Volvo_S90__Sedan_2018_5d_Hybrid (Electric)_EN.pdf',
      additionalHref: [
        {
          label: 'ENGLISH',
          href: '/ver/Volvo_S90__Sedan_2018_5d_Hybrid (Electric)_EN.pdf',
        },
        {
          label: 'FRENCH',
          href: '/ver/Volvo_S90__Sedan_2018_5d_Hybrid (Electric)_FR.pdf',
        },
        {
          label: 'SPANISH',
          href: '/ver/Volvo_S90__Sedan_2018_5d_Hybrid (Electric)_ES.pdf',
        },
      ],
    },
    {
      image: '/ver/V90 Electric.jpg',
      model: 'V90',
      year: '2018-2024',
      href: '/ver/Volvo_V90__Stationwagon_2018_5d_Hybrid (Electric)_EN.pdf',
      additionalHref: [
        {
          label: 'ENGLISH',
          href: '/ver/Volvo_V90__Stationwagon_2018_5d_Hybrid (Electric)_EN.pdf',
        },
        {
          label: 'FRENCH',
          href: '/ver/Volvo_V90__Stationwagon_2018_5d_Hybrid (Electric)_FR.pdf',
        },
        {
          label: 'SPANISH',
          href: '/ver/Volvo_V90__Stationwagon_2018_5d_Hybrid (Electric)_ES.pdf',
        },
      ],
    },
  ];

  const internalCombustionEngine = [
    {
      image: '/ver/S60.webp',
      model: 'S60',
      year: '2019-2022',
      href: '/ver/MY2019-S60.pdf',
    },
    {
      image: '/ver/S90.webp',
      model: 'S90',
      year: '2017-2022',
      href: '/ver/MY2017-18-S90.pdf',
    },
    {
      image: '/ver/V60CC.webp',
      model: 'V60',
      year: '2019-2022',
      href: '/ver/MY2019-V60-ICE.pdf',
    },
    {
      image: '/ver/V90CC.webp',
      model: 'V90',
      year: '2017-2022',
      href: '/ver/MY2017-18-V90andV90CC.pdf',
    },
    {
      image: '/ver/XC40.webp',
      model: 'XC40',
      year: '2018-2022',
      href: '/ver/MY2018-XC40.pdf',
    },
    {
      image: '/ver/XC60.webp',
      model: 'XC60',
      year: '2018-2022',
      href: '/ver/MY2018-XC60.pdf',
    },
    {
      image: '/ver/XC90.webp',
      model: 'XC90',
      year: '2016-2022',
      href: '/ver/MY2016-XC90.pdf',
    },
  ];

  const legacy = [
    {
      model: 'MY2001-MY2018',
      href: '/ver/MY2001-MY2018.pdf',
    },
    {
      model: 'MY1987-MY2005',
      href: '/ver/MY1987-MY2005.pdf',
    },
  ];

  return (
    <div className="content">
      <section>
        <VerParagraph bold={true}>
          Being focused on safety, Volvo has assembled this information for
          emergency personnel responding to traffic accidents.
        </VerParagraph>
        <VerParagraph>
          This information is a compilation of rescue information and SRS
          component descriptions and their locations for the following models
          and model years.
        </VerParagraph>
        <VerSubheader>Fully Electric</VerSubheader>
        <VerGrid items={rechargePureElectric} />
        <VerSubheader>Mild Hybrid</VerSubheader>
        <VerGrid items={mildHybrid} />
        <VerSubheader>Plug-In Hybrid</VerSubheader>
        <VerGrid items={pluginHybrid} />
        <VerSubheader>Internal Combustion Engine</VerSubheader>
        <VerGrid items={internalCombustionEngine} />
        <VerSubheader>Legacy</VerSubheader>
        <VerGrid items={legacy} />
      </section>
    </div>
  );
};

export default VerContainer;
